/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import useGeniatech from '../../../../../../../hooks/shared/geniatech/useGeniatech';
import GeniatechContext from '../../../../../../../context/GeniatechContext';
import { ALARMS_URL } from '../api/AlarmsUrl';

const AlarmsProvider = ({ children }) => {
  const { data, loading, pages, search, searchData, onChange, searchStatus, reset, fetched } = useGeniatech(
    {
      action: 'get_alarms',
      offset: '1',
      limit: '100',
      severity: 'minor',
    },
    `${ALARMS_URL}`,
  );
  return (
    <GeniatechContext.Provider
      value={{
        data,
        loading,
        search,
        searchData,
        pages,
        onChange,
        searchStatus,
        reset,
        fetched,
      }}
    >
      {children}
    </GeniatechContext.Provider>
  );
};
export default AlarmsProvider;
